import { render } from "./editQuote.vue?vue&type=template&id=99077e28&scoped=true"
import script from "./editQuote.vue?vue&type=script&lang=js"
export * from "./editQuote.vue?vue&type=script&lang=js"

import "./editQuote.vue?vue&type=style&index=0&id=99077e28&scoped=true&lang=css"

import exportComponent from "/var/www/html/conference/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99077e28"]])

export default __exports__